// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slider-main-wrapper,
.carousel-inner,
.carousel-item {
  width: 100%;
  height: 100%;
}

.slider-main-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/components/ImageSlider/slider.scss"],"names":[],"mappings":"AAAA;;;EAGI,WAAA;EACA,YAAA;AACJ;;AAGI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAAR","sourcesContent":[".slider-main-wrapper,\n.carousel-inner,\n.carousel-item {\n    width: 100%;\n    height: 100%;\n}\n\n.slider-main-wrapper{\n    img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
